import React from 'react';
import { Stack, Typography, Box, Alert } from '@mui/material';
import parse from 'html-react-parser';
import { translate as t } from 'hooks/useTranslations';

import type { VideoContentBlock } from '../../../_types/dtb';
import BrightcovePlayer from '../../_components/BrightcovePlayer';

interface VideoBlockPreviewProps {
  block: VideoContentBlock;
}

const VideoBlockPreview: React.FC<VideoBlockPreviewProps> = ({ block }) => {
  return (
    <Stack spacing={3}>
      {block.title && <Typography variant='subtitleSm'>{block.title}</Typography>}
      <Stack spacing={2}>
        {block.contentData?.videoUrl ? (
          <BrightcovePlayer videoUrl={block.contentData.videoUrl} />
        ) : (
          <Alert severity='warning'>{t('dtbs.library.detail.content.videoBlock.noVideoUrl')}</Alert>
        )}
        {block.contentData?.caption && <Box>{parse(block.contentData.caption || '')}</Box>}
      </Stack>
    </Stack>
  );
};

export default VideoBlockPreview;
